import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CropperDialogComponent } from './components/cropper-dialog/cropper-dialog.component';
import { ImageControlComponent } from './components/image-control/image-control.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CdkMenuModule } from '@angular/cdk/menu';
import { LoadingModule } from '../loading/loading.module';
import { ImageModule } from '../image/image.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [CropperDialogComponent, ImageControlComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule,
    MatTooltipModule,
    CdkMenuModule,
    ImageCropperModule,
    MatButtonModule,
    FormsModule,
    LoadingModule,
    ImageModule,
    MatProgressBarModule
  ],
  exports: [ImageControlComponent, CropperDialogComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ImgCropperModule { }
